import BaseModel from '../BaseModel';
import {ATTRIBUTE_TYPES, HitContainerAttribute} from '../../../components';

export default class Tag extends BaseModel {
  constructor({id, designation}) {
    super(id, null, designation);
  }

  static get fkName() {
    return 'tag_id';
  }
  static get apiRoute() {
    return 'tag';
  }
  static get detailPageRoute() {
    return 'CommonTagList';
  }
  static get listPageRoute() {
    return 'CommonTagList';
  }
  get fkName() {
    return Tag.fkName;
  }
  get apiRoute() {
    return Tag.apiRoute;
  }
  get listPageRoute() {
    return Tag.listPageRoute;
  }
  get detailPageRoute() {
    return Tag.detailPageRoute;
  }

  static get orderKey() {
    return 'designation';
  }
  static get orderOrder() {
    return 'asc';
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(['designation']);
  }

  static get allAttributes() {
    return {
      designation: new HitContainerAttribute(ATTRIBUTE_TYPES.STRING, {
        tableProperties: {
          header: 'hit-base.common.designation',
        },
      }),
    };
  }
}
